export type rangeElement = 'first' | 'second' | 'alone';

interface ChangeValues {
    value: number;
    max: number;
    min: number;
    step: number | undefined;
    currentValues: [number, number];
    element: rangeElement,
    range?: boolean
}


export const prepareRangeValueChange = ({ value, max, min, currentValues, element, range, step }: ChangeValues) => {
    let localValue = value
    if (max && localValue > max) {
        localValue = max;
    }

    if (min && localValue < min) {
        localValue = min;
    }

    if(range) {
        if (element === "first" && localValue >= currentValues[1]) {
            localValue = currentValues[1] - (step ?? 1);
        }
    
        if (element === "second" && localValue <= currentValues[0]) {
            localValue = currentValues[0] + (step ?? 1);
        }
    }

    return localValue
}